export default __webpack_public_path__ + "assets/dust-wind.5c2dfea6.svg";